import React from 'react';
import moment from 'moment';

import Clock from '../../../../../../../../assets/svgComponents/Clock';
import Calendar from '../../../../../../../../assets/svgComponents/Calendar';
import Check from '../../../../../../../../assets/svgComponents/Check';
import Trash from '../../../../../../../../assets/png/trash.png';

import ButtonComponent from '../../../../../../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import Spinner from '../../../../../../../common/genericComponents/spinner';
import scheduleUtils from '../../../../../../scheduleUtils';
import VIDABOO_CONSTANTS from '../../../../../../../../config/consts';

const MBookingOptionRow = ({
  isAnonymousPage,
  bookingOption,
  primaryTimezone,
  secondaryTimezone,
  currentUser,
  index,
  exBfiDto,
  approveBookingOptionMeeting,
  showAcceptMeetingIcon,
  showTrashIcon,
  showStrikeThrough,
  calendarContext,
  handleDeleteMeeting,
  handleClick,
  handlePickerStates,
  dateAndTimePickerStates,
  isSelected,
  showSpinner,
}) => {
  const isOverdue = bookingOption?.rangeEndTimeSender < new Date().getTime();
  let showTwoTimezones = false;
  if (secondaryTimezone && secondaryTimezone !== primaryTimezone)
    showTwoTimezones = true;

  const handleAcceptMeeting = (e) => {
    e.stopPropagation();
    if (!showSpinner) {
      if (calendarContext.setEditScheduleMeetingDto) {
        calendarContext.setEditScheduleMeetingDto(exBfiDto);
      }
      approveBookingOptionMeeting(exBfiDto, bookingOption);
    }
  };

  const scheduleSettingsDto = isAnonymousPage
    ? currentUser.mentorDto.scheduleSettingsDto
    : currentUser.scheduleSettingsDto;

  return (
    <div className="et-n-events-date-wrapper-main" key={index}>
      <div
        className={`et-n-events-date-wrapper ${
          isSelected ? 'et-n-events-date-wrapper-selected' : ''
        }`}>
        <div
          className="et-n-events-calendar-wrapper"
          onClick={(e) => {
            e.stopPropagation();
            handleClick && handleClick(bookingOption);
          }}>
          <div
            className="et-n-events-time-wrap"
            onClick={() => {
              handlePickerStates && handlePickerStates(false, false, true);
            }}>
            <Calendar
              fillColor={
                isAnonymousPage
                  ? 'var(--et-mentor-cta-btn-primary-background-color)'
                  : '#2d275688'
              }
            />
            <div
              className={
                calendarContext?.selectedBookingOption?.rangeStartTimeSender ===
                  bookingOption?.rangeStartTimeSender &&
                dateAndTimePickerStates?.showDatePicker
                  ? 'et-n-events-date-time-wrap et-n-btn-active'
                  : 'et-n-events-date-time-wrap'
              }>
              <div
                className={`
                  ${
                    showStrikeThrough
                      ? 'et-n-events-calendar-day-strike-through'
                      : 'et-n-events-calendar-day'
                  } ${isOverdue ? 'et-n-events-date-time-overdue' : ''}`}>
                {scheduleUtils.getTimeZoneSpecficDayStr(
                  bookingOption?.rangeStartTimeSender,
                  primaryTimezone,
                )}
              </div>
              <div
                className={`
                  ${
                    showStrikeThrough
                      ? 'et-n-events-calendar-year-strike-through'
                      : 'et-n-events-calendar-year'
                  } ${isOverdue ? 'et-n-events-date-time-overdue' : ''}`}>
                {scheduleUtils.getTimeZoneSpecficYearStr(
                  bookingOption?.rangeStartTimeSender,
                  primaryTimezone,
                )}
              </div>
            </div>
          </div>
          <Clock
            fillColor={
              isAnonymousPage
                ? 'var(--et-mentor-cta-btn-primary-background-color)'
                : '#2d275688'
            }
          />
          <div
            className={`
              ${
                showStrikeThrough
                  ? 'et-n-events-calendar-time-strike-through'
                  : 'et-n-events-calendar-time'
              } ${isOverdue ? 'et-n-events-date-time-overdue' : ''}`}>
            <div
              className={
                calendarContext?.selectedBookingOption?.rangeStartTimeSender ===
                  bookingOption?.rangeStartTimeSender &&
                dateAndTimePickerStates?.showStartTimePicker
                  ? 'et-n-events-start-time et-n-btn-active'
                  : 'et-n-events-start-time'
              }
              onClick={() => {
                handlePickerStates && handlePickerStates(true, false, false);
              }}>
              {moment(bookingOption?.rangeStartTimeSender)
                .tz(primaryTimezone)
                .format(
                  scheduleSettingsDto?.timeFormat ===
                    VIDABOO_CONSTANTS.TIME_FORMAT.TWELVE_HOUR
                    ? 'h:mma'
                    : 'H:mm',
                )}
            </div>
            <div className="et-n-events-start-end-space">-</div>
            <div
              className={
                calendarContext?.selectedBookingOption?.rangeStartTimeSender ===
                  bookingOption?.rangeStartTimeSender &&
                dateAndTimePickerStates?.showEndTimePicker
                  ? 'et-n-events-end-time et-n-btn-active'
                  : 'et-n-events-end-time'
              }
              onClick={() => {
                handlePickerStates && handlePickerStates(false, true, false);
              }}>
              {moment(bookingOption?.rangeEndTimeSender)
                .tz(primaryTimezone)
                .format(
                  scheduleSettingsDto?.timeFormat ===
                    VIDABOO_CONSTANTS.TIME_FORMAT.TWELVE_HOUR
                    ? 'h:mma'
                    : 'H:mm',
                )}
              {false &&
                showTwoTimezones &&
                ' | ' +
                  moment(bookingOption?.rangeStartTimeSender)
                    .tz(secondaryTimezone)
                    .format(
                      scheduleSettingsDto?.timeFormat ===
                        VIDABOO_CONSTANTS.TIME_FORMAT.TWELVE_HOUR
                        ? 'h:mm'
                        : 'H:mm',
                    ) +
                  ' - ' +
                  moment(bookingOption?.rangeEndTimeSender)
                    .tz(secondaryTimezone)
                    .format(
                      scheduleSettingsDto?.timeFormat ===
                        VIDABOO_CONSTANTS.TIME_FORMAT.TWELVE_HOUR
                        ? 'h:mm A'
                        : 'H:mm',
                    )}
            </div>
          </div>
        </div>
        {isOverdue && (
          <div className="et-n-events-date-overdue-pill">Passed</div>
        )}
        {!isOverdue && showAcceptMeetingIcon && (
          <div
            className={
              showSpinner ? 'et-n-events-calander-approve-disable-events' : ''
            }>
            {showSpinner && isSelected ? (
              <div className="et-n-events-calander-approve et-n-smallest-spinner">
                <Spinner />
              </div>
            ) : (
              <div className="et-n-events-calander-approve-wrap">
                {!isAnonymousPage ? (
                  <div
                    className="et-n-events-calander-approve"
                    onClick={(e) => handleAcceptMeeting(e)}>
                    <Check
                      color={
                        isAnonymousPage
                          ? 'var(--et-mentor-cta-btn-primary-background-color)'
                          : '#2D2756'
                      }
                    />
                  </div>
                ) : (
                  <ButtonComponent
                    type="primary-outlined"
                    text="Accept"
                    onClick={(e) => handleAcceptMeeting(e)}
                  />
                )}
              </div>
            )}
          </div>
        )}
        {showTrashIcon && (
          <div className="et-n-cec-edit-trash-wrap">
            {/* <div className="et-n-cec-edit">
              <img className="et-n-cec-edit-icon" src={Edit} alt={'edit'} />
            </div>{' '} */}

            <div className="et-n-cec-trash">
              <img
                className="et-n-cec-trash-icon"
                src={Trash}
                alt={'trash'}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteMeeting(index);
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MBookingOptionRow;
